// extracted by mini-css-extract-plugin
export default {"bookContainer":"BookDetails_bookContainer__D396X","bookDetails":"BookDetails_bookDetails__s-YML","buttonGroup":"BookDetails_buttonGroup__QhB0y"};